import React from 'react';
import { Form, Input } from 'antd';
import valid from 'card-validator';
import useElements from '../../hooks/useElements';

const elementType = 'holder';
function CardHolderElement({ onChange, defaultValue, placeholder = 'Nome do Titular' }) {
  const form = Form.useFormInstance();
  const [_, setElements] = useElements();
  
  return (
    <Form.Item 
      name={elementType}
      label={placeholder}
      initialValue={defaultValue}
      rules={[
        { required: true, message: `${placeholder} é obrigatório.`, },
        { min: 3, message: `${placeholder} deve conter no mínimo 3 caracteres.` },
        { 
          validator: (_, value) => {
            const validation = valid.cardholderName(value);
            const { isValid } = validation || {};
            return isValid ? Promise.resolve() : Promise.reject(new Error('Should accept agreement'))
          },
          message: `${placeholder} não é válido.`
        },
      ]}
    >
      <Input 
        id={`${elementType}-input`}
        placeholder={placeholder}  
        size="large" 
        onChange={(event) => {
          if (!onChange) return;
          setTimeout(() => {
            const errors = form.getFieldError(elementType);  
            const payload = {
              elementType,
              complete: errors.length <= 0, 
              [elementType]: event.target.value,
              errors,
            };
            setElements((oldState) => ({ ...oldState, [elementType]: payload }));
            onChange(payload);
          }, 1);
        }}
      />
    </Form.Item>
  )
};

export default CardHolderElement;